<template>
  <vx-card title="Données de volume de recherche">
    <div class="vx-row float-right">
      <vs-button
        color="primary"
        type="filled"
        class="mb-4 mr-4"
        @click="updateKeywordsData"
        >Actualiser les données</vs-button
      >
    </div>
    <!--<span>Source de données utilisée pour la recherche: {{ keywordsResult.source }}</span> <br />
                <span>Localisation de la recherche: {{ keywordsResult.region.name }}</span> -->
    <vs-table max-items="10" pagination :data="keywordsData">
      <template slot="thead">
        <vs-th style="width: 50px;"></vs-th>
        <vs-th>Mot clé</vs-th>
        <vs-th>
          <vx-tooltip
            title="Position"
            text="Position moyenne sur le mois."
            position="top"
            class="w-full txt_align_right"
          >
            <span>Position</span>
          </vx-tooltip>
        </vs-th>
        <vs-th
          ><span class="txt_align_right w-full"
            >Recherches mensuelle</span
          ></vs-th
        >
        <vs-th>
          <vx-tooltip
            title="Compétition"
            text="Plus cette valeur est proche de 1, plus il est difficile de se positionner sur ce mot clé (concurrence)."
            position="top"
            class="w-full txt_align_right"
          >
            <span>Compétition</span>
          </vx-tooltip>
        </vs-th>
        <vs-th>
          <vx-tooltip
            title="CPC"
            text="Coût par clic (référencement payant)."
            position="top"
            class="w-full txt_align_right"
          >
            <span>Coût par clic</span>
          </vx-tooltip>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr slot="header" :key="index" v-for="(row, index) in data">
          <vs-td style="width: 50px;">
            <div
              class="expand-icon-wrapper"
              @click="toggleExpand(index)"
              v-if="row.monthlySearchVolumes && row.monthlySearchVolumes.length > 0"
              style="cursor: pointer; display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 24px;"
            >
              <vs-icon
                :icon="expandedRows[index] ? 'keyboard_arrow_down' : 'keyboard_arrow_right'"
                size="small"
                style="pointer-events: none"
              />
            </div>
          </vs-td>
          <vs-td>{{ row.keyword }}</vs-td>
          <vs-td class="fw-bold txt_align_right">{{ row.position }}</vs-td>
          <vs-td class="fw-bold txt_align_right">{{ row.searchVolume }}</vs-td>
          <vs-td
            v-if="row.hasOwnProperty('competition')"
            class="txt_align_right"
            >{{ parseFloat(row.competition).toFixed(2) }}</vs-td
          >
          <vs-td v-else class="txt_align_right">-</vs-td>
          <vs-td
            v-if="row.hasOwnProperty('costPerClick')"
            class="txt_align_right"
            >{{ parseFloat(row.costPerClick).toFixed(2) }} €</vs-td
          >
          <vs-td v-else class="txt_align_right">-</vs-td>
        </vs-tr>
        <tr
          v-if="expandedRows[index]"
          :key="'expand-' + index"
          class="expand-row"
        >
          <td :colspan="6" style="padding: 10px;">
            <vs-table stripe :data="row.monthlySearchVolumes">
              <template slot="thead">
                <vs-th>Date</vs-th>
                <vs-th
                  ><span class="txt_align_right w-full"
                    >Volume de recherche</span
                  ></vs-th
                >
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="index" v-for="(row2, index) in data">
                  <vs-td>{{ row2.month }} / {{ row2.year }}</vs-td>
                  <vs-td class="fw-bold txt_align_right">{{
                    row2.count
                  }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </td>
        </tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
import utilsMixin from "@/mixins/utilsMixin";

export default {
	name: "SemanticTable",
	props: {
		keywordsData: Array
	},
	mixins: [utilsMixin],
	data() {
		return {
			expandedRows: {}
		};
	},
	methods: {
		toggleExpand(index) {
			this.$set(this.expandedRows, index, !this.expandedRows[index]);
		},
		/**
		 * Ask parent component to update the keywords data
		 * Georanker keywords data
		 */
		updateKeywordsData() {
			this.$emit("updateKeywordsData");
		}
	}
};
</script>

<style scoped>
.txt_align_right {
  text-align: right;
}

.fw-bold {
  font-weight: bold;
}

.expand-row td {
  background-color: #ffffffff;
  padding: 20px !important;
}

.expand-icon-wrapper:hover {
  background-color: #f0f0f0;
  border-radius: 4px;
}
</style>
